import { useRoute } from 'vue-router';
import { BOPS_NAME, SDD_FACET } from '@utils/constants';

let route;

export default function checkingRouteForSysPage() {
  route = useRoute();
  let splittedRoute;
  try {
    const {
      params: { pathMatch },
    } = route;

    let isPickupInRoute = false;

    for (let i = 0; i < pathMatch.length; i++) {
      splittedRoute = pathMatch[i].split(',');
      /* istanbul ignore else */
      if (splittedRoute.includes('pickup-delivery')) {
        isPickupInRoute = true;
      } else if (
        isPickupInRoute && (splittedRoute.includes(BOPS_NAME)
                || splittedRoute.includes(SDD_FACET))
      ) {
        return true;
      }
    }
    return false;
  } catch (error) {
    return false;
  }
}
